module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.edb159c5.png";